const filterButtons = document.querySelectorAll('.button--filter') as NodeListOf<HTMLAnchorElement>;
const articles = document.querySelectorAll('.listing-page__article') as NodeListOf<HTMLElement>;
const urlParams = new URLSearchParams(window.location.search);
const showMoreButtonContainer = document.querySelector('.listing-page__show-more-link-container') as HTMLElement;
const sortSelect = document.getElementById('sortOrder') as HTMLSelectElement;

if (showMoreButtonContainer) {
    showMoreButtonContainer.addEventListener('click', () => {
        saveScrollPosition();
    });
}

// Add the active class to the selected filter button
function makeActive(button: HTMLAnchorElement): void {
    button.classList.add('button--active');
    button.setAttribute('aria-current', 'true');
}

// Set the default filter
function setDefaultFilter(): void {
    const filterQueryString: string | null = urlParams.get('filter');
    const yearQueryString: string | null = urlParams.get('year');

    if (filterButtons.length > 0) {
        if (!filterQueryString && !yearQueryString) {
            makeActive(filterButtons[0]);
        } else if (filterQueryString || yearQueryString) {
            // Loop through the filter buttons and set the active class to the button that matches the query string
            filterButtons.forEach((button: HTMLAnchorElement) => {
                const buttonText = button.textContent?.trim();

                if (filterQueryString === buttonText || yearQueryString === buttonText) {
                    makeActive(button);

                    const resultHeading = document.querySelector('.listing-page__heading') as HTMLElement;
                    if (resultHeading) {
                        scrollIntoViewManual(resultHeading);
                    }
                }
            });
        }

    }
}

// Scroll to the first article if the take query string is present
function scrollNextElementIntoView(): void {
    const takeQueryString: string | null = urlParams.get('take');
    const filterQueryString: string | null = urlParams.get('filter');

    if (!!takeQueryString || !!filterQueryString && articles.length > 0) {
        let scrollToElement = document.querySelector('.listing-page__section-container') as HTMLElement;

        // If the filter section is present, scroll to the filter section
        if (document.querySelector(".listing-page__filter-section")) {
            scrollToElement = document.querySelector('.listing-page__filter-section') as HTMLElement;
        }

        scrollIntoViewManual(scrollToElement);
    }
}

// Scroll to element
function scrollIntoViewManual(element: HTMLElement): void {
    if (element) {
        const rect = element.getBoundingClientRect();
        const headerElementHeight = (document.querySelector(".header") as HTMLHeadElement).scrollHeight;
        const offsetHeight = 250;

        setTimeout(() => {
            window.scrollTo({ top: rect.top - headerElementHeight - offsetHeight, behavior: 'smooth' });
        }, 10);
    }
}

// Save scroll position before reloading
function saveScrollPosition(): void {
    sessionStorage.setItem('scrollPosition', window.scrollY.toString());
}

// Restore scroll position after page reload
function restoreScrollPosition(): void {
    const savedScrollPosition = sessionStorage.getItem('scrollPosition');
    if (savedScrollPosition) {
        setTimeout(() => {
            window.scrollTo({ top: parseInt(savedScrollPosition, 10), behavior: 'smooth' });
            
            // Remove scroll position from sessionStorage after restoring it
            sessionStorage.removeItem('scrollPosition');
        }, 50);
    }
}

function listenForSortChange(): void {
    if (sortSelect) {
        sortSelect.addEventListener('change', () => {
            const selectedValue = sortSelect.value;
            const url = new URL(window.location.href);
            url.searchParams.set('sortType', selectedValue);
            window.location.href = url.toString();
        });
    }
}

restoreScrollPosition();
scrollNextElementIntoView();
setDefaultFilter();
listenForSortChange();